{
  "version": 1,
  "asset_id": "703b0cd9-d749-4f3e-b3fa-5ebacbfa90b9",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/703b0cd9-d749-4f3e-b3fa-5ebacbfa90b9/okapi.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/703b0cd9-d749-4f3e-b3fa-5ebacbfa90b9/okapi.webp",
  "original_filename": "okapi.webp",
  "size": 139266,
  "content_type": "image/webp",
  "created_at": "2026-07-21T20:12:27Z"
}
